define([
    '../questionsets/QuestionSetService',
    './QuestionSetDirective',
    './config/SpecialQuestionsConfig',
    './BaslerQuestionSetService',
    'portalConfig',
], (QuestionSetService, BaslerQuestionSetDirective, BaslerSpecQuestionsConfig, BaslerQuestionSetService)=> {
    //This module is showing QuestionSets. It reuses OOTB QuestionSet module for format data and inject aspects
    //however it decorates questions with Basler specific info
    return angular.module('edge.platform.baslerquestionsets', ['portal.config', 'edge.platform.basler'])
        .directive('baslerQuestionSet', BaslerQuestionSetDirective)
        .provider('QuestionSetService', QuestionSetService)
        .constant('BASLER_QUESTIONSET_CONFIG', BaslerSpecQuestionsConfig)
        .provider('BaslerQuestionSetService', BaslerQuestionSetService);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/baslerquestionsets/module.js